import recaptcha from '@components/App/RecaptchaWidget/recaptcha'
import { App } from '@components/AppMain/App'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import { createRoot } from 'react-dom/client'

import './assets/css/main.css'
import './assets/css/overlay-roots.css'

import { GlobalActions } from '@/store'
import { store } from '@/store/store'

// @TODO review, do we actualy need to use this library
TimeAgo.addDefaultLocale(en)

store.dispatch(GlobalActions.appEntry())

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)

recaptcha.render()
